export const GET_ASSIGNED_LIST = "GET_ASSIGNED_LIST";
export const GET_UNASSIGNED_LIST = "GET_UNASSIGNED_LIST";
export const GET_UNASSIGNED_COUNT = "GET_UNASSIGNED_COUNT";
export const GET_ASSIGNED_COUNT = "GET_ASSIGNED_COUNT";
export const GET_BUILDING_LIST = "GET_BUILDING_LIST";
